export const APP_NAME = "Du'a Workspace";
export const APP_TAGLINE =
  "Your private space for everything you ask Allah for.";
export const APP_VERSION = "0.1.0";
export const LIBRARY_EDITION = "1.0";

